const FILE_TYPE_REGEX = /image\/(.*)/i;

export const DEFAULT_FILE_NAME = 'noname';

export const getSafeFileNameFromFile = (file: File): string => {
    return !file.name || file.name.trim() === ''
        ? DEFAULT_FILE_NAME
        : file.name;
};

export const getSafeFileTypeFromFile = (file: File): string => {
    const fileTypeMatch = FILE_TYPE_REGEX.exec(file.type);
    const fileType = fileTypeMatch ? fileTypeMatch[1] : '';

    return fileType;
};
